import React, { useState, useEffect } from "react";
import {
  Paper,
  Typography,
  Grid,
  InputBase,
  IconButton,
  Menu,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ThemeProvider,
  Pagination,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import ListTheme from "./styles";
import Atomic from "../../AComponent/Atomic";
import Molecule from "../../MComponent/Molecule";
import { Search } from "@mui/icons-material";
import ConfirmationButton from "../../AComponent/Buttons/ConfirmationButton";
import Gateway from "../../Utils/Api/Gateway";
import { v4 as uuid } from "uuid";
import Urls from "../../Utils//index";
import AlertMessage from "../../Utils/Messages/AlertMessage";
import useWindowDimensions from "../../Utils/CustomHooks/WindowRezise";
import { Actions } from "../../Redux/Actions/Actiontypes";
import { getDateFromEpoch } from "../../Utils/Common/Library";
import { LoadingButton } from "@mui/lab";
import AddImageForm from "./AddImageForm";
const { Button, Input } = Atomic;
const { EwModal } = Molecule;
const { TAM_URL } = Urls;

const newData = [
  {
    WorkLocationName: "abc",
    WorkLocationCode: "123",
    devices: [
      {
        deviceId: "abcc-abc-abc",
        admin: {
          username: "8888888888",
          password: "pass",
        },
        users: [
          {
            username: "8888888888",
            password: "pass",
          },
          {
            username: "8888888888",
            password: "pass",
          },
        ],
      },
    ],
  },
];
const ExpandMoreIcon = () => (
  <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.75 1.91828L2.33625 0.332031L7.5 5.48453L12.6638 0.332032L14.25 1.91828L7.5 8.66828L0.75 1.91828Z"
      fill="#212121"
    />
  </svg>
);

const PersonIcon = () => (
  <svg width="20" height="20" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.82536 4.0445H2.42214C1.91258 4.0451 1.42409 4.25361 1.06371 4.62429C0.703381 4.99497 0.500638 5.49755 0.5 6.02182V7.7428C0.499973 7.81102 0.526296 7.87646 0.573187 7.9247C0.620075 7.97294 0.683673 8.00003 0.749976 8H7.49725C7.56355 8.00003 7.62715 7.97294 7.67404 7.9247C7.72093 7.87646 7.74725 7.81102 7.74723 7.7428V6.02182C7.74658 5.49757 7.54387 4.99501 7.18359 4.62429C6.82329 4.25361 6.33491 4.04513 5.82536 4.0445ZM7.24734 7.48541H6.02574V6.16759C6.02574 6.0757 5.9781 5.99079 5.90077 5.94486C5.8234 5.8989 5.72812 5.8989 5.65076 5.94486C5.57343 5.99079 5.52576 6.0757 5.52576 6.16759V7.48541H3.03957L3.0396 6.16759C3.0396 6.0757 2.99193 5.99079 2.9146 5.94486C2.83727 5.8989 2.74196 5.8989 2.66462 5.94486C2.58726 5.99079 2.53963 6.0757 2.53963 6.16759V7.48541H1.00001V6.02187C1.00052 5.634 1.1505 5.26216 1.41711 4.98794C1.68371 4.71371 2.04516 4.55948 2.42215 4.55904H5.82537C6.20233 4.5595 6.56375 4.71379 6.83028 4.98801C7.09686 5.26223 7.24685 5.63405 7.24735 6.02187L7.24734 7.48541ZM4.12368 3.66863C4.47632 3.66863 4.821 3.56104 5.1142 3.35944C5.40739 3.15788 5.63591 2.87137 5.77082 2.53619C5.90576 2.20097 5.94103 1.83214 5.87221 1.4763C5.80339 1.12047 5.63353 0.793629 5.38415 0.537096C5.13479 0.280563 4.81706 0.105911 4.47117 0.0351888C4.12533 -0.0355339 3.76686 0.000859368 3.4411 0.139746C3.11532 0.278659 2.83693 0.513842 2.64109 0.815558C2.44526 1.11727 2.34077 1.47194 2.34085 1.83475C2.34152 2.32098 2.52956 2.78708 2.86378 3.13092C3.198 3.47471 3.65108 3.66808 4.12368 3.66863ZM4.12368 0.514427C4.46393 0.514427 4.79022 0.653482 5.03077 0.901007C5.27132 1.14853 5.4065 1.48425 5.4065 1.83429C5.4065 2.18433 5.27135 2.52005 5.03077 2.76757C4.79019 3.0151 4.4639 3.15415 4.12368 3.15415C3.78346 3.15415 3.45717 3.0151 3.2166 2.76757C2.97599 2.52002 2.84085 2.18431 2.84085 1.83429C2.84125 1.48436 2.97653 1.14886 3.21703 0.901431C3.45752 0.653989 3.78356 0.514815 4.12368 0.514427Z"
      fill="black"
    />
  </svg>
);
const UsersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.05776 0C3.48465 0 3.87119 0.172692 4.15092 0.451678C4.43051 0.730919 4.60358 1.11657 4.60358 1.54249C4.60358 1.96834 4.43051 2.35387 4.15092 2.63319C3.87121 2.9123 3.48472 3.08487 3.05776 3.08487C2.63087 3.08487 2.24446 2.9123 1.9647 2.63319C1.68498 2.35395 1.51192 1.96843 1.51192 1.54249C1.51192 1.11663 1.68498 0.73094 1.9647 0.451678C2.24446 0.172692 2.63082 0 3.05776 0ZM5.91014 4.34427H7.09006C7.31166 4.34427 7.52446 4.38546 7.72113 4.46025C7.8584 4.17758 8.0568 3.93559 8.29624 3.75591C8.58142 3.54228 8.92436 3.41715 9.29202 3.41715H10.4718C10.9651 3.41715 11.4126 3.64133 11.7362 4.00256C12.0554 4.35875 12.2534 4.8483 12.2534 5.38531V8.32787C12.2534 8.43876 12.2448 8.5477 12.2286 8.65404C12.2119 8.76248 12.1873 8.86841 12.1549 8.97119C12.1318 9.04483 12.0637 9.09197 11.9901 9.09197V9.09247H8.87132V9.82793C8.87132 9.92281 8.7942 9.99996 8.6988 9.99996L4.3014 10C4.20595 10 4.12859 9.92293 4.12859 9.82798V9.09251L1.00987 9.09247C0.928567 9.09247 0.860658 9.03638 0.842032 8.96125C0.811086 8.86141 0.787483 8.75892 0.771429 8.65404C0.755252 8.54762 0.746582 8.43876 0.746582 8.32786V5.38531C0.746582 4.84832 0.944741 4.35877 1.26382 4.00256C1.58739 3.64128 2.03493 3.41714 2.52817 3.41714H3.70788C4.07567 3.41714 4.4183 3.54215 4.70367 3.75591C4.94323 3.93559 5.14139 4.17757 5.27877 4.46025C5.4754 4.38545 5.68821 4.34427 5.91009 4.34427L5.91014 4.34427ZM8.02967 4.61357C8.14524 4.68568 8.25218 4.77061 8.34813 4.86635C8.67102 5.18843 8.87126 5.63286 8.87126 6.12204V8.74734H11.8588C11.8698 8.70003 11.8792 8.65185 11.887 8.60251C11.9002 8.51364 11.9075 8.42208 11.9075 8.32758L11.9075 5.38523C11.9075 4.93471 11.7437 4.52641 11.4797 4.23148C11.2198 3.94169 10.8631 3.76188 10.4717 3.76188H9.29184C9.00051 3.76188 8.72897 3.86106 8.50252 4.03069C8.30635 4.17784 8.14307 4.37822 8.02967 4.61345V4.61357ZM4.12852 6.31252V6.12215C4.12852 5.63284 4.32883 5.18841 4.65177 4.86635C4.74759 4.77073 4.85453 4.68567 4.97022 4.61357C4.85681 4.37821 4.69383 4.17792 4.49733 4.0308C4.27112 3.8613 3.99946 3.762 3.70813 3.762H2.52842C2.13683 3.762 1.77988 3.94193 1.5204 4.2316C1.25637 4.52648 1.09223 4.93477 1.09223 5.38535V8.32791C1.09223 8.42237 1.09949 8.51393 1.11301 8.60284C1.12052 8.65218 1.12985 8.70036 1.14118 8.74767H4.12842L4.12852 6.31252ZM7.08996 4.68923H5.91003C5.70449 4.68923 5.50861 4.73298 5.33123 4.81167C5.31555 4.83138 5.29543 4.84793 5.27158 4.85948C5.03418 4.99389 4.83361 5.2004 4.69278 5.4533C4.55439 5.70241 4.47408 5.99729 4.47408 6.31254V9.65532H8.52603V8.91998L8.52611 6.31248C8.52611 5.99728 8.44585 5.7024 8.3073 5.45325C8.16456 5.19752 7.96093 4.98887 7.72008 4.85471C7.70021 4.84341 7.68299 4.82864 7.66922 4.81175C7.49172 4.73306 7.29534 4.68919 7.08992 4.68919L7.08996 4.68923ZM6.50008 0.983615C6.07306 0.983615 5.68665 1.15631 5.40681 1.43554C5.12722 1.71452 4.95415 2.10018 4.95415 2.52624C4.95415 2.95209 5.12722 3.33762 5.40681 3.61694C5.68665 3.89618 6.07301 4.06875 6.50008 4.06875C6.92672 4.06875 7.31338 3.89618 7.59324 3.61694C7.8727 3.3377 8.04577 2.95218 8.04577 2.52624C8.04577 2.10027 7.87283 1.71457 7.59324 1.43554C7.3134 1.1563 6.92675 0.983615 6.50008 0.983615ZM7.3488 1.6793C7.13152 1.46261 6.83119 1.32846 6.50008 1.32846C6.16851 1.32846 5.86839 1.46261 5.65122 1.6793C5.43407 1.89599 5.29974 2.19543 5.29974 2.5262C5.29974 2.8568 5.43418 3.15628 5.65122 3.3731C5.86838 3.58978 6.16847 3.72382 6.50008 3.72382C6.83128 3.72382 7.13152 3.5898 7.3488 3.3731C7.56584 3.15628 7.7004 2.85684 7.7004 2.5262C7.70036 2.1953 7.56579 1.89583 7.3488 1.6793ZM9.94218 6.37061e-05C10.3691 6.37061e-05 10.7555 0.172629 11.0352 0.451742C11.3151 0.730982 11.4883 1.11663 11.4883 1.54255C11.4883 1.96841 11.3152 2.35393 11.0352 2.63326C10.7555 2.91237 10.369 3.08493 9.94218 3.08493C9.5154 3.08493 9.12875 2.91237 8.84912 2.63326C8.5694 2.35401 8.39634 1.96849 8.39634 1.54255C8.39634 1.1167 8.56927 0.731004 8.84912 0.451742C9.12871 0.172756 9.51536 6.37061e-05 9.94218 6.37061e-05ZM10.7907 0.695632C10.5734 0.478943 10.2737 0.344791 9.94218 0.344791C9.61086 0.344791 9.31061 0.478943 9.09362 0.695632C8.87634 0.912321 8.74177 1.21176 8.74177 1.54236C8.74177 1.87296 8.87634 2.17257 9.09362 2.38926C9.31066 2.60595 9.61099 2.73998 9.94218 2.73998C10.2736 2.73998 10.5735 2.60583 10.7907 2.38926C11.008 2.17257 11.1423 1.87301 11.1423 1.54236C11.1423 1.21176 11.008 0.912279 10.7907 0.695632ZM3.90647 0.695632C3.68932 0.478943 3.38923 0.344791 3.05775 0.344791C2.7263 0.344791 2.42618 0.478943 2.20902 0.695632C1.99186 0.912321 1.85754 1.21176 1.85754 1.54236C1.85754 1.87296 1.99198 2.17257 2.20902 2.38926C2.42618 2.60595 2.72626 2.73998 3.05775 2.73998C3.38919 2.73998 3.68932 2.60583 3.90647 2.38926C4.12376 2.17257 4.25796 1.87301 4.25796 1.54236C4.25791 1.21176 4.12372 0.912279 3.90647 0.695632Z"
      fill="black"
    />
  </svg>
);
const GearIcon = () => (
  <svg width="20" height="20" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.467 7.02142L10.4292 7.30425L10.6536 7.48059L11.772 8.35977L10.7439 10.1375L9.41768 9.60478L9.15155 9.49788L8.92491 9.67364C8.65195 9.88532 8.3538 10.0616 8.03042 10.1931L7.76411 10.3014L7.72377 10.5861L7.52337 12H5.47052L5.27012 10.5861L5.22978 10.3014L4.96347 10.1931C4.64259 10.0626 4.3493 9.88665 4.06511 9.67067L3.83934 9.49908L3.5762 9.60478L2.24995 10.1375L1.22229 8.36051L2.35092 7.48207L2.58598 7.29912L2.53702 7.0053C2.5115 6.85221 2.50007 6.67469 2.50007 6.5C2.50007 6.34526 2.52041 6.16936 2.54952 5.9947L2.59848 5.70088L2.36342 5.51793L1.23447 4.63924L2.25655 2.86264L3.58245 3.39522L3.84464 3.50053L4.07012 3.33027C4.35018 3.1188 4.65002 2.93694 4.96972 2.8069L5.23603 2.69857L5.27637 2.41391L5.47677 1H7.52962L7.73002 2.41391L7.77036 2.69857L8.03667 2.8069C8.35754 2.93742 8.65083 3.11335 8.93503 3.32933L9.16079 3.50092L9.42393 3.39522L10.7502 2.8625L11.7778 4.63949L10.6492 5.51793L10.4142 5.70088L10.4631 5.9947C10.4887 6.14811 10.5001 6.31949 10.5001 6.5C10.5001 6.68576 10.4888 6.85736 10.467 7.02142ZM11.9178 4.53057C11.9179 4.53049 11.918 4.53041 11.9181 4.53032L11.918 4.53043L11.9178 4.53057ZM3.75007 6.5C3.75007 8.01364 4.98643 9.25 6.50007 9.25C8.01371 9.25 9.25007 8.01364 9.25007 6.5C9.25007 4.98636 8.01371 3.75 6.50007 3.75C4.98643 3.75 3.75007 4.98636 3.75007 6.5Z"
      stroke="black"
      stroke-opacity="0.6"
    />
  </svg>
);
const DeleteIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3513 2.59459C11.3513 2.41623 11.2054 2.27027 11.027 2.27027H8.8378V1.07026C8.8378 0.486486 8.35131 0 7.76755 0H3.58377C3 0 2.51351 0.486486 2.51351 1.07026V2.27027H0.324324C0.145959 2.27027 0 2.41623 0 2.59459C0 2.77296 0.145959 2.91892 0.324324 2.91892H1.54054V10.8811C1.54054 11.4973 2.04323 12 2.65947 12H8.87027C9.48652 12 9.9892 11.4973 9.9892 10.8811L9.98915 2.91892H11.0432C11.2054 2.91892 11.3513 2.77296 11.3513 2.59459H11.3513ZM3.16213 1.07027C3.16213 0.843229 3.3567 0.648662 3.58374 0.648662H7.76752C7.99456 0.648662 8.18913 0.843229 8.18913 1.07027V2.27028H3.1621L3.16213 1.07027ZM9.32429 10.8811C9.32429 11.1405 9.11345 11.3514 8.854 11.3514H2.65942C2.39997 11.3514 2.18913 11.1405 2.18913 10.8811V2.91892H9.32426L9.32429 10.8811Z"
      fill="black"
    />
    <path
      d="M3.80968 4.50781C3.63131 4.50781 3.48535 4.65377 3.48535 4.83214V9.53483C3.48535 9.7132 3.63131 9.85916 3.80968 9.85916C3.98804 9.85916 4.134 9.7132 4.134 9.53483V4.83214C4.134 4.63751 3.98804 4.50781 3.80968 4.50781Z"
      fill="black"
    />
    <path
      d="M5.75596 4.50781C5.5776 4.50781 5.43164 4.65377 5.43164 4.83214V9.53483C5.43164 9.7132 5.5776 9.85916 5.75596 9.85916C5.93433 9.85916 6.08029 9.7132 6.08029 9.53483V4.83214C6.08029 4.63751 5.93433 4.50781 5.75596 4.50781Z"
      fill="black"
    />
    <path
      d="M7.70323 4.50781C7.52487 4.50781 7.37891 4.65377 7.37891 4.83214V9.53483C7.37891 9.7132 7.52487 9.85916 7.70323 9.85916C7.88159 9.85916 8.02755 9.7132 8.02755 9.53483V4.83214C8.02755 4.63751 7.88159 4.50781 7.70323 4.50781Z"
      fill="black"
    />
  </svg>
);
const HiddenIcon = () => (
  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 0.25C3.5 0.25 1.365 1.805 0.5 4C1.365 6.195 3.5 7.75 6 7.75C8.5 7.75 10.635 6.195 11.5 4C10.635 1.805 8.5 0.25 6 0.25ZM6 6.5C4.62 6.5 3.5 5.38 3.5 4C3.5 2.62 4.62 1.5 6 1.5C7.38 1.5 8.5 2.62 8.5 4C8.5 5.38 7.38 6.5 6 6.5ZM6 2.5C5.17 2.5 4.5 3.17 4.5 4C4.5 4.83 5.17 5.5 6 5.5C6.83 5.5 7.5 4.83 7.5 4C7.5 3.17 6.83 2.5 6 2.5Z"
      fill="black"
      fill-opacity="0.56"
    />
  </svg>
);

const DeviceIcon = ({ height, width }) => (
  <svg
    width={width ? width : "20"}
    height={height ? height : "20"}
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33326 8.33277C5.33326 8.10238 5.1469 7.91602 4.91651 7.91602H4.08326C3.85287 7.91602 3.6665 8.10238 3.6665 8.33277C3.6665 8.56303 3.85287 8.74939 4.08326 8.74939H4.91651C5.1469 8.74939 5.33326 8.56303 5.33326 8.33277Z"
      fill="black"
    />
    <path
      d="M7.41663 8.33339V9.16664H1.58338V0.833378H7.41663V5.8334H8.25001V0.833378C8.25001 0.374762 7.87488 0 7.41663 0H1.58338C1.12513 0 0.75 0.374762 0.75 0.833378V9.16675C0.75 9.62487 1.12513 10 1.58338 10H7.41663C7.87488 10 8.25001 9.62487 8.25001 9.16662V8.33337L7.41663 8.33339Z"
      fill="black"
    />
  </svg>
);
const EditIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.982265 11.0177H1.70259L8.95498 3.76535L8.23465 3.04502L0.982265 10.2974V11.0177ZM11.0341 3.06139L8.93861 0.965894L9.62619 0.278308C9.81173 0.0927694 10.0409 0 10.3138 0C10.5866 0 10.8158 0.0927694 11.0014 0.278308L11.7217 0.998636C11.9072 1.18417 12 1.41337 12 1.68622C12 1.95907 11.9072 2.18827 11.7217 2.37381L11.0341 3.06139ZM10.3465 3.74898L2.0955 12H0V9.9045L8.25102 1.65348L10.3465 3.74898ZM8.59482 3.40518L8.23465 3.04502L8.95498 3.76535L8.59482 3.40518Z"
      fill="black"
    />
  </svg>
);

const passwordRegex = "^(?=.*\\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,16}$";
const passwordMsg =
  "Password does not meet the requirements. Please ensure it has at least 8 characters at most 16, contains at least one number, one special character, one uppercase letter, and one lowercase letter.";
const mobileRegex = "^[0-9]{10}$";
const mobileMsg = "Invalid phone number. Please enter a 10-digit number.";
const endPointMap = {
  registerDevice: "/face-recognition/tam/device/register",
  activate: "/face-recognition/tam/device/installBDA",
  deactivate: "/face-recognition/tam/device/deactivate",
  getAllDevices: "/getAllDevices",
  newDeviceId: "/face-recognition/tam/device/changedevice",
};
function LocationDetails({ reviewMode, cardProps, setModal, deviceIds }) {
  //const { WorkLocationName, WorkLocationCode, devices, setModal } = cardProps;
  const [passwordMap, setPassowrdMap] = useState({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [openRegenerate, setOpenRegenerate] = useState(null);
  const [loadingRegenerate, setLoadingRegenerate] = useState(false);
  const [errorRegenerate, setErrorReGenerate] = useState(null);
  const [successRegenerate, setSuccessReGenerate] = useState(null);

  const [localState, setLocalState] = useState({
    WorkLocationName: cardProps.WorkLocationName,
    WorkLocationCode: cardProps.WorkLocationCode,
    devices: cardProps.devices,
  });
  function updateDeviceId(oldDeviceId, newDeviceId) {
    const devices = [...localState.devices];
    const index = devices.findIndex((item) => item.deviceId === oldDeviceId);
    if (index !== -1) {
      devices[index].deviceId = newDeviceId;
      setLocalState((prev) => ({ ...prev, devices: [...devices] }));
    }
  }
  const [error, setError] = useState({
    admin: null,
    user: null,
    save: null,
  });
  const { WorkLocationName, WorkLocationCode, devices } = localState;
  const { width } = useWindowDimensions();
  function updateState(val, type) {
    setLocalState((prev) => ({ ...prev, [type]: val }));
  }
  function validate(type, val) {
    if (type === 1) {
      let regexExp = new RegExp(passwordRegex);
      return regexExp.test(val);
    } else {
      let regexExp = new RegExp(mobileRegex);
      return regexExp.test(val);
    }
  }
  function onSave() {
    setSaveLoading(true);
    let payload = { ...localState };
    for (let i = 0; i < payload?.devices?.length; i++) {
      const {
        admin: { username },
      } = payload.devices[i];

      if (!username || username?.trim(" ") === "") {
        payload.devices[i].admin = {};
      }
    }

    Gateway({
      url: TAM_URL + "face-recognition/tam/tenant/addWorkLocation",
      payload: payload,
    })
      .then((res) => {
        if (res && res.status === 1) {
          setModal(null);
        } else {
          setError((prev) => ({ ...prev, save: "Save Failed" }));
        }
        console.log("Result is: ", res);
      })
      .catch((e) => {
        setError((prev) => ({ ...prev, save: "Network Error" }));
        console.log("TAM Error is: ", e);
      })
      .finally(() => {
        setSaveLoading(false);
      });
  }
  function reGenerateDeviceId() {
    if (!openRegenerate?.deviceId) return;
    setLoadingRegenerate(true);
    const oldDeviceId = openRegenerate.deviceId;
    Gateway({
      url: TAM_URL + "face-recognition/tam/device/changedevice",
      payload: {
        DeviceID: openRegenerate.deviceId,
        Status: openRegenerate.status,
      },
    })
      .then((res) => {
        console.log("regenerate reult: ", res);
        setOpenRegenerate(null);
        setSuccessReGenerate({
          newDeviceId: res?.deviceId || "",
          oldDeviceId,
        });
        updateDeviceId(oldDeviceId, res.deviceId);
      })
      .catch((e) => {
        console.log("Erro us: ", e.response);
        if (e?.response?.data?.errorMessage) {
          setErrorReGenerate(e.response.data.errorMessage);
        } else {
          setErrorReGenerate("Something went wrong");
        }
      })
      .finally(() => {
        setLoadingRegenerate(false);
      });
  }
  function onDelete(username, newItem, index, userIndex) {
    if (newItem === true) {
      removeFromArr();
      return;
    }
    function removeFromArr() {
      let obj = localState;
      obj.devices[index].users.splice(userIndex, 1);
      setLocalState({ ...obj });
    }
    let payload = {
      username,
    };
    Gateway({
      url: TAM_URL + "face-recognition/tam/user/delete",
      type: "DELETE",
      payload,
    })
      .then((res) => {
        if (res && res.status === 1) {
          removeFromArr();
        } else {
          setError((prev) => ({
            ...prev,
            user: "Could Not Delete User " + username,
          }));
        }
        console.log("AFter delete: ", res);
      })
      .catch((e) => {
        setError((prev) => ({ ...prev, user: "Nework Error" }));
      });
  }
  function generateRandomText() {
    //const alphaSet = new Set(['abc123', 'def456', 'ghi789']); // Replace with your existing alphanumeric strings
    let count = 0;
    while (true) {
      count++;
      let randomText = "";
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 6; i++) {
        randomText += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      if (!deviceIds) {
        return randomText;
      }

      if (!deviceIds.has(randomText)) {
        return randomText;
      }
      if (count > 1000) return null;
    }
  }
  return (
    <div
      // className="scroll"
      style={{
        width: 0.6 * width,
        maxHeight: 500,
        overflowX: "hidden",
        position: "relative",
      }}
    >
      <EwModal
        open={Boolean(openRegenerate)}
        onClose={() => {
          setOpenRegenerate(null);
        }}
      >
        <Stack minHeight={100} mt={4} gap={2}>
          <Typography>Are you sure you want to regenerate device id?</Typography>
          <Typography>Current Device ID: {openRegenerate?.deviceId}</Typography>
          {errorRegenerate && (
            <AlertMessage message={errorRegenerate} onClose={() => setErrorReGenerate(null)} />
          )}
          <Stack direction={"row"} gap={2} justifyContent={"flex-end"}>
            <Button
              variant={"text"}
              label={"cancel"}
              onClick={() => {
                setOpenRegenerate(null);
              }}
            />
            <LoadingButton
              variant="contained"
              loading={loadingRegenerate}
              onClick={reGenerateDeviceId}
              color="success"
            >
              Confirm
            </LoadingButton>
            {/* <Button label={"Confirm"} onClick={() => {}} color={"success"} /> */}
          </Stack>
        </Stack>
      </EwModal>
      {/* <span
        onClick={() => setModal(null)}
        className="pointer"
        style={{ position: "absolute", right: 10, top: 5 }}
      >
        <CloseIcon sx={{ fontSize: 30 }} />
      </span> */}
      <div style={{ width: "100%", padding: 20 }}>
        <Input
          styles={{ width: "100%" }}
          variant="standard"
          label={"Work Location Name"}
          value={WorkLocationName}
          onChange={(val) => updateState(val, "WorkLocationName")}
        />
        <Input
          styles={{ width: "100%" }}
          variant="standard"
          label={"Work Location Code"}
          value={WorkLocationCode}
          onChange={(val) => updateState(val, "WorkLocationCode")}
        />
      </div>
      <br />
      <Typography variant="h4" style={ListTheme["typography/headings/h4"]}>
        Devices
      </Typography>
      <br />
      <div style={{ marginLeft: 10, marginRight: 10 }}>
        {devices?.map(({ deviceId, admin, users, status, LastActiveTime }, index) => (
          <Accordion
            sx={{
              boxShadow:
                "0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.2)",
              mb: 2,
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} id={"devices" + index}>
              <div
                className="Flex-row"
                style={{
                  justifyContent: "flex-start",
                  width: "100%",
                  paddingRight: 20,
                  gap: 30,
                }}
              >
                <Typography style={ListTheme["typography/paragraph/p3"]}>
                  {"Device#" + (index + 1)}
                </Typography>
                <Typography variant="typography/Form/form_text3">
                  <UsersIcon /> {admin.username ? admin.username : "--:--"}
                </Typography>
                <Typography variant="typography/Form/form_text3">
                  <DeviceIcon height={15} width={15} />
                  {" " + users.length + " Users"}
                </Typography>
                {LastActiveTime && (
                  <Typography variant="typography/Form/form_text3">
                    Last Active On:{" "}
                    {getDateFromEpoch({
                      epoch: LastActiveTime,
                      includeTime: true,
                    })}
                    {}
                  </Typography>
                )}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <>
                <div className="Flex-row" style={{ justifyContent: "space-between" }}>
                  <Typography sx={{ fontFamily: "monospace" }}>
                    {"Device ID : " + deviceId}
                    {deviceId?.trim(" ") === "" &&
                      "Save the document to assign a device ID, as it is currently unassigned."}
                  </Typography>
                  <Stack direction={"row"} gap={3} alignItems={"center"}>
                    {status === "1" ? (
                      <span
                        className="pointer"
                        onClick={() => {
                          let obj = localState;
                          obj.devices[index].status = "0";

                          setLocalState({ ...obj });
                        }}
                      >
                        <Typography style={{ color: "lightgreen" }}>Active</Typography>
                      </span>
                    ) : (
                      <span
                        className="pointer"
                        onClick={() => {
                          let obj = localState;
                          obj.devices[index].status = "1";

                          setLocalState({ ...obj });
                        }}
                      >
                        <Typography color={"error"}>De-activated</Typography>
                      </span>
                    )}
                    <Typography>{" | "}</Typography>
                    <Button
                      variant={"text"}
                      label={"Re-Generate Device ID"}
                      onClick={() => {
                        setOpenRegenerate({ deviceId, status });
                      }}
                    />
                  </Stack>
                </div>
                {successRegenerate?.newDeviceId && deviceId === successRegenerate?.newDeviceId && (
                  <AlertMessage
                    message={`Device Id Changed From ${successRegenerate?.oldDeviceId} to ${successRegenerate.newDeviceId} `}
                    onClose={() => setSuccessReGenerate(null)}
                    type={0}
                  />
                )}
                <br />
                <Typography style={ListTheme["typography/paragraph/p3"]}>Device Admin</Typography>
                <br />
                {admin.edit || !admin.username || admin.username?.trim(" ") === "" ? (
                  <>
                    <Input
                      regex={mobileRegex}
                      errorMsg={mobileMsg}
                      styles={{ width: "80%" }}
                      label={"Mobile No"}
                      placeholder={"Add Admin's 10 digit phone no."}
                      value={admin.username}
                      onChange={(val) => {
                        let obj = localState;
                        obj.devices[index].admin.username = val;
                        setLocalState({ ...obj });
                      }}
                    />
                    <br />
                    <div
                      className="Flex-row "
                      style={{
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        gap: 10,
                      }}
                    >
                      <div style={{ width: "40%" }}>
                        <Input
                          regex={passwordRegex}
                          errorMsg={passwordMsg}
                          styles={{ width: "100%" }}
                          label={"Set Password"}
                          placeholder={"Set a password for admin"}
                          value={admin.password}
                          onChange={(val) => {
                            let obj = localState;
                            obj.devices[index].admin.password = val;
                            setLocalState({ ...obj });
                          }}
                        />
                      </div>
                      <div style={{ width: "40%" }}>
                        <Input
                          regex={passwordRegex}
                          errorMsg={passwordMsg}
                          styles={{ width: "100%" }}
                          label={"Confirm Password"}
                          placeholder={"Re-enter the password"}
                          value={admin.confirmPassword}
                          onChange={(val) => {
                            let obj = localState;
                            obj.devices[index].admin.confirmPassword = val;
                            setLocalState({ ...obj });
                          }}
                        />
                      </div>
                      {error.admin && (
                        <AlertMessage
                          message={error.admin}
                          onClose={() => setError((prev) => ({ ...prev, admin: null }))}
                        />
                      )}
                    </div>
                    <span
                      className="pointer"
                      style={{ marginLeft: 20 }}
                      onClick={() => {
                        let obj = localState;
                        const { username, password, confirmPassword } = obj.devices[index].admin;
                        if (username === "" || password === "" || confirmPassword === "") {
                          setError((prev) => ({
                            ...prev,
                            user: "All Fields Are Required",
                          }));
                          return;
                        }
                        if (password !== confirmPassword) {
                          setError((prev) => ({
                            ...prev,
                            user: "Password Does Not Match",
                          }));
                          return;
                        }
                        if (!validate(1, password) || !validate(2, username)) {
                          return;
                        }
                        if (
                          username === "" ||
                          password === "" ||
                          confirmPassword === "" ||
                          password !== confirmPassword
                        )
                          return;
                        obj.devices[index].admin.edit = false;
                        setLocalState({ ...obj });
                      }}
                    >
                      <Typography style={{ color: "#3FA147", fontSize: 13 }} variant="small_text1">
                        Add
                      </Typography>
                    </span>
                    <br />
                  </>
                ) : (
                  <>
                    <div style={{ display: "flex" }}>
                      <Typography
                        variant="small_text1"
                        style={{ flex: 0.35, ...ListTheme["small_text1"] }}
                      >
                        {"Username"}
                      </Typography>
                      <Typography
                        variant="small_text1"
                        style={{ flex: 0.35, ...ListTheme["small_text1"] }}
                      >
                        {"Password"}
                      </Typography>
                      <Typography variant="small_text1" style={{ flex: 0.3 }}>
                        {""}
                      </Typography>
                    </div>
                    <br />
                    <div style={{ display: "flex" }}>
                      <div style={{ flex: 0.35 }}>
                        {" "}
                        <Typography style={{ display: "inline" }} variant="h6">
                          {admin.username}
                        </Typography>
                      </div>
                      <div
                        style={{
                          flex: 0.25,
                          gap: 20,
                          justifyContent: "flex-start",
                        }}
                        className="Flex-row"
                      >
                        {passwordMap["admin" + index]
                          ? admin.password
                          : admin.password?.split("").map(() => "*")}
                        <span
                          className="pointer"
                          style={{ marginRight: 40, marginBottom: 5 }}
                          onClick={() => {
                            let obj = passwordMap;
                            let key = "admin" + index;
                            if (!obj[key]) obj[key] = true;
                            else obj[key] = false;
                            setPassowrdMap({ ...obj });
                          }}
                        >
                          <HiddenIcon />
                        </span>
                      </div>
                      <div
                        onClick={() => {
                          let obj = localState;
                          let admin = obj.devices[index].admin;
                          admin.edit = true;
                          admin.confirmPassword = admin.password;
                          obj.devices[index].admin = admin;
                          setLocalState({ ...obj });
                        }}
                        className="pointer"
                        style={{ flex: 0.1 }}
                      >
                        <EditIcon />
                      </div>
                    </div>
                    {/* <Typography variant="typography/Paragraph/p3">
                      {"Mobile No: "}{" "}
                   
                    </Typography> */}
                    {/* <br /> */}
                    {/* <Typography>
                      {"Password: "}{" "}
                      <Typography style={{ display: "inline" }} variant="h6">
                        {!passwordMap["admin" + index] ? (
                          <>{admin.password?.split("").map(() => "*")}</>
                        ) : (
                          <>{admin.password}</>
                        )}
                        {"  "}
                        <span
                          style={{ marginLeft: 40 }}
                          className="pointer"
                          onClick={() => {
                            let obj = passwordMap;
                            let key = "admin" + index;
                            if (!obj[key]) obj[key] = true;
                            else obj[key] = false;
                            setPassowrdMap({ ...obj });
                          }}
                        >
                          <HiddenIcon />
                        </span>
                      </Typography>
                    </Typography> */}
                    <br />
                  </>
                )}
                <br />
                <div className="Flex-row g20">
                  <div></div>
                </div>

                <Typography style={ListTheme["typography/paragraph/p3"]}>Device Users</Typography>
                <br />
                {users?.length > 0 && (
                  <div className="Flex-row">
                    <Typography
                      variant="small_text1"
                      style={{ flex: 0.35, ...ListTheme["small_text1"] }}
                    >
                      {"Username"}
                    </Typography>
                    <Typography
                      variant="small_text1"
                      style={{ flex: 0.35, ...ListTheme["small_text1"] }}
                    >
                      {"Password"}
                    </Typography>
                    <Typography variant="small_text1" style={{ flex: 0.3 }}>
                      {""}
                    </Typography>
                  </div>
                )}
                <br />
                <div style={{ maxHeight: 400 }}>
                  {users?.map(
                    ({ username, password, userEditMode, confirmPassword, newItem }, userIndex) => (
                      <>
                        {!userEditMode ? (
                          <div className="Flex-row ">
                            <div style={{ flex: 0.35 }}>{username}</div>
                            <div
                              style={{
                                flex: 0.25,
                                gap: 20,
                                justifyContent: "flex-start",
                              }}
                              className="Flex-row"
                            >
                              {passwordMap[index + "users" + userIndex]
                                ? password
                                : password?.split("").map(() => "*")}
                              <span
                                className="pointer"
                                style={{ marginRight: 40, marginBottom: 5 }}
                                onClick={() => {
                                  let obj = passwordMap;
                                  let key = index + "users" + userIndex;
                                  obj[key] = !obj[key];
                                  setPassowrdMap({ ...obj });
                                }}
                              >
                                <HiddenIcon />
                              </span>
                            </div>
                            <div style={{ flex: 0.1 }}>
                              <span
                                className="pointer"
                                onClick={() => {
                                  let obj = localState;
                                  let user = obj.devices[index].users[userIndex];
                                  user.userEditMode = true;
                                  user.confirmPassword = user.password;
                                  obj.devices[index].users[userIndex] = user;
                                  setLocalState({ ...obj });
                                }}
                              >
                                <EditIcon />
                              </span>
                            </div>
                            <div style={{ flex: 0.3 }}>
                              <ConfirmationButton
                                ButtonComponent={({ openModal }) => (
                                  <span
                                    className="pointer"
                                    onClick={() => {
                                      openModal(true);
                                    }}
                                  >
                                    <DeleteIcon />
                                  </span>
                                )}
                                message="Are you sure you want to delete this user?"
                                onClick={() => onDelete(username, newItem, index, userIndex)}
                              />
                            </div>
                          </div>
                        ) : (
                          <>
                            <Input
                              regex={mobileRegex}
                              errorMsg={mobileMsg}
                              styles={{ width: "80%" }}
                              label={"Username"}
                              placeholder={"Add Device User's 10 digit phone no."}
                              value={username}
                              onChange={(val) => {
                                let obj = localState;
                                obj.devices[index].users[userIndex].username = val;
                                setLocalState({ ...obj });
                              }}
                            />
                            <br />
                            <div
                              className="Flex-row "
                              style={{
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                                gap: 10,
                              }}
                            >
                              <div style={{ width: "40%" }}>
                                <Input
                                  regex={passwordRegex}
                                  errorMsg={passwordMsg}
                                  styles={{ width: "100%" }}
                                  label={"Set Password"}
                                  placeholder={"Set a password for user"}
                                  value={password}
                                  onChange={(val) => {
                                    let obj = localState;
                                    obj.devices[index].users[userIndex].password = val;
                                    setLocalState({ ...obj });
                                  }}
                                />
                              </div>
                              <div style={{ width: "40%" }}>
                                <Input
                                  regex={passwordRegex}
                                  errorMsg={passwordMsg}
                                  styles={{ width: "100%" }}
                                  label={"Confirm Password"}
                                  placeholder={"Re-enter the password"}
                                  value={confirmPassword}
                                  onChange={(val) => {
                                    let obj = localState;
                                    obj.devices[index].users[userIndex].confirmPassword = val;
                                    setLocalState({ ...obj });
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              style={{
                                width: "20%",
                                justifyContent: "space-around",
                              }}
                              className="Flex-row"
                            >
                              <br />
                              {error.user && (
                                <AlertMessage
                                  message={error.user}
                                  onClose={() =>
                                    setError((prev) => ({
                                      ...prev,
                                      user: null,
                                    }))
                                  }
                                />
                              )}
                              <span
                                className="pointer"
                                style={{ marginLeft: 20 }}
                                onClick={() => {
                                  if (
                                    username === "" ||
                                    password === "" ||
                                    confirmPassword === ""
                                  ) {
                                    setError((prev) => ({
                                      ...prev,
                                      user: "All Fields Are Required",
                                    }));
                                    return;
                                  }
                                  if (password !== confirmPassword) {
                                    setError((prev) => ({
                                      ...prev,
                                      user: "Password Does Not Match",
                                    }));
                                    return;
                                  }
                                  if (!validate(1, password) || !validate(2, username)) {
                                    return;
                                  }
                                  let obj = localState;
                                  obj.devices[index].users[userIndex].userEditMode = false;
                                  setLocalState({ ...obj });
                                }}
                              >
                                <Typography
                                  style={{ color: "#3FA147", fontSize: 13 }}
                                  variant="small_text1"
                                >
                                  Add
                                </Typography>
                              </span>

                              <div
                                className="pointer"
                                onClick={() => {
                                  let obj = localState;
                                  obj.devices[index].users.splice(userIndex, 1);
                                  setLocalState({ ...obj });
                                }}
                              >
                                <Typography style={{ fontSize: 13 }} variant="small_text1">
                                  Cancel
                                </Typography>
                              </div>
                            </div>
                            <br />
                          </>
                          // <div className="Flex-row">
                          //   <div
                          //     className="Flex"
                          //     style={{ flex: 0.35, alignItems: "flex-start" }}
                          //   >
                          //     <Input
                          //       variant="standard"
                          //       label={"Username"}
                          //       value={username}
                          //       onChange={(val) => {
                          //         let obj = localState;
                          //         obj.devices[index].users[userIndex].username =
                          //           val;
                          //         console.log("TAM obj: 1", obj);
                          //         setLocalState({ ...obj });
                          //       }}
                          //     />
                          //   </div>
                          //   <div
                          //     className="Flex"
                          //     style={{ flex: 0.35, alignItems: "flex-start" }}
                          //   >
                          //     <Input
                          //       variant="standard"
                          //       label={"Passowrd"}
                          //       value={password}
                          //       onChange={(val) => {
                          //         let obj = localState;
                          //         obj.devices[index].users[userIndex].password =
                          //           val;
                          //         console.log("TAM obj: ", obj);
                          //         setLocalState({ ...obj });
                          //       }}
                          //     />
                          //   </div>
                          //   <div style={{ flex: 0.3 }}>
                          //     <div className="pointer">
                          //       <Button
                          //         title={"Save"}
                          //         onClick={() => {
                          //           let obj = localState;
                          //           const { username, password } =
                          //             obj.devices[index].users[userIndex];
                          //           if (
                          //             username.trim(" ") === "" ||
                          //             password.trim(" ") === ""
                          //           )
                          //             return;
                          //           obj.devices[index].users[
                          //             userIndex
                          //           ].userEditMode = false;
                          //           setLocalState({ ...obj });
                          //         }}
                          //       />
                          //     </div>
                          //   </div>
                          // </div>
                        )}
                      </>
                    )
                  )}
                </div>
                <br />
                <Button
                  variant={"text"}
                  title={"Add another user"}
                  onClick={() => {
                    let obj = localState;

                    let users = obj.devices[index].users;
                    let lastIndex = users.length - 1;
                    if (lastIndex !== -1 && users[lastIndex].userEditMode === true) return;
                    users.push({
                      userEditMode: true,
                      newItem: true,
                      username: "",
                      password: "",
                      confirmPassword: "",
                    });
                    obj.devices[index].users = users;
                    setLocalState({ ...obj });
                  }}
                />
              </>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
      <br />
      <Button
        variant={"text"}
        title={"Add Another Device"}
        onClick={() => {
          let obj = localState;
          if (!obj.devices) obj.devices = [];
          obj.devices.push({
            // deviceId: uuid(),
            // deviceId: generateRandomText(),
            deviceId: "",
            admin: {
              edit: true,
              username: "",
              password: "",
            },
            users: [],
          });
          setLocalState({ ...obj });
        }}
      />
      {/* <span className="pointer">
        <Typography style={ListTheme["typography/Paragraph/p5"]}></Typography>
      </span> */}

      {/* <Button variant={"text"} title={"Add Another Device"} /> */}
      <br />
      {error.save && (
        <>
          <AlertMessage
            message={error.save}
            onClose={() => setError((prev) => ({ ...prev, save: null }))}
          />
          <br />
        </>
      )}
      <div className="Flex">
        {" "}
        <Button
          disable={saveLoading}
          variant="outlined"
          color={"success"}
          label={"Save"}
          onClick={onSave}
        />
      </div>
      <br />
      <br />
    </div>
  );
}
function Card(props) {
  const { WorkLocationName, WorkLocationCode, devices, setModal, deviceIds } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  function getUsers(devices) {
    if (!devices) return 0;
    let count = 0;
    devices.forEach(({ users }) => {
      if (users) count += users.length;
    });
    return count;
  }
  return (
    <>
      <Paper
        style={{
          width: 250,
          height: 200,
          padding: 10,
          position: "relative",
          zIndex: 0,
          boxShadow:
            "0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.2)",
          borderRadius: 6,
        }}
        className="Flex"
      >
        <br />
        <div style={{ position: "absolute", right: 5, top: 5 }}>
          <div
            className="pointer"
            onClick={() =>
              setModal(
                <LocationDetails cardProps={props} setModal={setModal} deviceIds={deviceIds} />
              )
            }
          >
            <GearIcon />
          </div>
        </div>
        <Typography variant="p4">{WorkLocationName}</Typography>
        <br />
        <Typography variant="p4">{WorkLocationCode}</Typography>
        <br />
        <Typography>
          <DeviceIcon />
          {"  "}
          {devices && devices.length > 0 ? devices.length : "No Devices Added Yet"}
          {devices.length > 0 && " Devices"}
        </Typography>
        <br />
        <Typography variant="typography/Form/form_text3">
          <UsersIcon />
          {"  "}
          {getUsers(devices) + " Users"}
        </Typography>
        <br />
      </Paper>
    </>
  );
}

function List({ type, setTab }) {
  const [data, setData] = useState([]);
  const [dataCopy, setDataCopy] = useState([]);
  const [modal, setModal] = useState(null);
  const [deviceIds, setDeviceIds] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchStr, setSearch] = useState("");
  const [openAddImage, setOpenAddImage] = useState(false);

  const [paginaion, setPagination] = useState({
    limit: 16,
    page: 1,
    totalPages: 0,
  });
  const dispatch = useDispatch();
  // const [modal, setModalOpen] = useState(false);
  function changePage(page) {
    let startIndex = page - 1;
    let endIndex = startIndex + paginaion.limit;
    if (startIndex < 0 || endIndex > dataCopy.length) return;
    setData((prev) => dataCopy.slice(startIndex, endIndex).filter((item) => item));
    setPagination((prev) => ({ ...prev, page }));
  }
  function getData() {
    //setLoading(true);
    Gateway({
      url: TAM_URL + "face-recognition/tam/tenant/getWorkLocation",
      type: "GET",
    })
      .then((res) => {
        let arr = [...res];
        // for (let i = 0; i < 20; i++) {
        //   arr = [...arr, ...res];
        // }
        if (arr.length > paginaion.limit) {
          setData(arr.slice(0, paginaion.limit));
        } else {
          setData(arr);
        }

        setDataCopy(arr);
        setSearch("");
        console.log("Get Result: ", res);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  useEffect(() => {
    if (modal === null) getData();
  }, [modal]);

  function search(str) {
    setSearch(str);
    if (str === "") {
      setData(dataCopy);
      return;
    }
    let arr = [];
    arr = dataCopy?.filter((item) =>
      JSON.stringify(item).toLowerCase().includes(str.toLowerCase())
    );
    setData([...arr]);
  }
  useEffect(() => {
    // Gateway({
    //   url: TAM_URL + endPointMap.getAllDevices,
    //   type: "GET",
    // });
    // dispatch({
    //   type: Actions.ADD_SIDE_COMPONENT,
    //   payload: {
    //     Component: () => <></>,
    //   },
    // });
  }, []);
  if (loading) return <>Loading</>;

  return (
    <>
      {/* <ThemeProvider theme={ListTheme}> */}
      <EwModal open={modal ? true : false} onClose={() => setModal(null)}>
        {modal}
      </EwModal>
      <EwModal open={openAddImage} onClose={() => setOpenAddImage(false)}>
        <AddImageForm onClose={() => setOpenAddImage(false)} />
      </EwModal>
      <div className="Flex-row">
        <div className="Flex" style={{ flex: 1 }}>
          {" "}
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "flex-end",
              width: 400,
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Devices"
              inputProps={{ "aria-label": "search devices" }}
              onChange={(e) => search(e.target.value)}
              value={searchStr}
            />
            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
              <Search />
            </IconButton>
          </Paper>
        </div>
        <Stack direction={"row"} spacing={2} style={{ flex: 0.4 }}>
          <Button
            startIcon={<UsersIcon />}
            variant="text"
            label={"Upload Faces"}
            onClick={() => setOpenAddImage(true)}
          />

          <Button
            color={"success"}
            variant="outlined"
            title={"Add New Location"}
            onClick={() => {
              setModal(<LocationDetails cardProps={{}} setModal={setModal} />);
            }}
          />
        </Stack>
      </div>
      <br />
      <Typography style={{ marginLeft: 10 }} variant="h2">
        My Devices
      </Typography>
      <br />
      <br />
      <Grid container spacing={5}>
        {data.map((ele) => (
          <Grid md={3} item>
            <Card {...ele} setModal={setModal} deviceIds={deviceIds || new Set()} />
          </Grid>
        ))}
      </Grid>
      <br />
      {dataCopy.length > paginaion.limit && (
        <div className="Flex">
          <Pagination
            count={paginaion.limit}
            page={paginaion.page}
            onChange={(e, page) => changePage(page)}
            color="secondary"
            on
          />
        </div>
      )}
      <br />
      {/* </ThemeProvider> */}
    </>
  );
}

export default List;
